import {
	SET_LANGUAGE,
} from './action-types';

export function setLanguage(language) {
	return {
		type: SET_LANGUAGE,
		language,
	};
}

